import React from 'react';

import { Button } from '@metarouter-private/mr-mui';

import { useBulkDeployPageContext } from '../../BulkDeployPageContext';

export default function GetPipelinesButton() {
  const { handleGetPipelines, isDeploying } = useBulkDeployPageContext();

  return (
    <Button variant="contained" onClick={handleGetPipelines} disabled={isDeploying} data-test-id="getPipelinesButton">
      {isDeploying ? 'Deploying...' : 'Refresh'}
    </Button>
  );
}
